import { render, staticRenderFns } from "./CounterpartiesDetail.vue?vue&type=template&id=8e815506&"
import script from "./CounterpartiesDetail.vue?vue&type=script&lang=js&"
export * from "./CounterpartiesDetail.vue?vue&type=script&lang=js&"
import style0 from "./CounterpartiesDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports